export enum SchoolEnums {
  ALL_SCHOOLS = 'All Schools',
}
